import React from "react";
import { gql } from "apollo-boost";

import AskAQuestion from "../AskAQuestion";
import RequestForm from "../RequestForm";
import * as S from "./styled";

export const genQuery = queryType =>
  `mutation ${queryType}($input: ContactAgentInput!) {
    ${queryType}(input: $input) {
      ... on ContactAgentResult {
        recipients {
          name
        }
      }
      ... on ContactAgentErrors {
        errors {
          type
          messages
        }
      }
    }
  }`;

const buildConfirmation = (listedByName, type) => {
  const confirmationHeader = `You sent a ${type}`;
  const emailRecipients = " You and any search partners you've included";

  const confirmationText = (
    <>
      <S.Bold>{listedByName}</S.Bold> will review your {type}.{emailRecipients}{" "}
      will receive a confirmation email shortly.
    </>
  );

  return { confirmationHeader, confirmationText };
};

const LeadType = {
  question: {
    type: "question",
    title: "Ask a question",
    component: AskAQuestion,
    confirmation: listedByName => buildConfirmation(listedByName, "question"),
    buttonCaption: "Send Question",
    subtitle: null,
    ga_events: {
      click: "click_to_ask_question",
      send: "ask_question"
    },
    mutation: gql`
      ${genQuery("ask_question")}
    `,
    email_details: ({ question }, unit) => ({
      email_content: question,
      email_subject: `About your listing, Unit ${unit}.`
    })
  },
  request: {
    type: "request",
    title: "Request a tour",
    buttonCaption: "Send Request",
    subtitle: "Your preferred day and time may not be available.",
    component: RequestForm,
    confirmation: listedByName => buildConfirmation(listedByName, "request"),
    ga_events: {
      click: "click_to_request_tour",
      send: "request_tour"
    },
    mutation: gql`
      ${genQuery("request_tour")}
    `,
    email_details: ({ datetimes, message, tourType }) => {
      let preferredTimeOfDayString = "";
      let preferredTourDateString = "";
      const emailSubject = "tour request";
      if (datetimes[0].date || datetimes[0].time) {
        preferredTimeOfDayString = datetimes
          .map(datetime => datetime.time)
          .join(",");
        preferredTourDateString = datetimes
          .map(datetime => datetime.date)
          .join(",");
      }
      return {
        email_content: message,
        email_subject: emailSubject,
        preferred_time_of_day: preferredTimeOfDayString,
        preferred_tour_date: preferredTourDateString,
        tour_type: tourType
      };
    }
  }
};

export default LeadType;
